export const formatSnakeCase = (snakeCaseString: string): string => {
  if (!snakeCaseString || typeof snakeCaseString !== "string") {
    return snakeCaseString;
  }

  const words = snakeCaseString.split("_");
  let result = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  // Remove the last 's' if it exists
  if (result.endsWith("s")) {
    result = result.slice(0, -1);
  }

  return result;
};
